// Events list page (CHG-1254 / ITER-3379).
//
// Thin per the v2-canary pattern: page file ≤30 LOC, configuration in
// @generated/screens. Future generator regenerates eventListConfig from
// event.entity-hint.yaml (CHG-1235) without touching this file.
//
// Spec: specs/tier-05-experience/events-v2.cross-screen.yaml.
// Point-in-time entity (no StageChip / no ambient row) — same recipe as
// CHG-1243 / CHG-1249 / CHG-1251.

import { ListPage } from "../components/composition";
import { eventListConfig } from "../generated/screens/event-list";

export function Events() {
  return <ListPage config={eventListConfig} />;
}
